module.exports = __webpack_public_path__ + "static/media/3.5cf0de15.jpg";